import React, { useState } from "react";
import AlertMessage from "../../../partials/alertMessage";

const DutyPeriodUpdateForm = ({ onSubmit, currentValue, onCancel }) => {
	const [message, setMessage] = useState(null);
	const nameRef = React.createRef();
	// Update current value
	setTimeout(() => {
		if (nameRef && nameRef.current) nameRef.current.value = currentValue;
	}, 0);
	return (
		<form
			method="POST"
			onSubmit={e => {
				e.preventDefault();
				const name = nameRef.current.value;
				if (name) {
					onSubmit(name);
					setMessage(null);
					nameRef.current.value = "";
				} else {
					setMessage("Duty Period is required!");
				}
			}}
		>
			<AlertMessage message={message} failed={true} />
			<div className="form-group">
				<input
					type="text"
					id="update-duty"
					name="update-duty"
					ref={nameRef}
					className="form-control input-height"
					placeholder="duty name .."
				/>
			</div>
			<div className="text-center">
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-js-ripple-effect m-l-10 m-t-5 margin-right-10 btn-circle btn-default"
				>
					<i className="material-icons text-danger">cancel</i> Cancel
				</button>

				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 m-t-5 btn-circle btn-success"
				>
					Update <i className="material-icons">arrow_right_alt</i>
				</button>
			</div>
		</form>
	);
};
export default DutyPeriodUpdateForm;
